<template>
    
    <keep-alive>

        <m_header v-if="flag"/>
        <p_header v-else/>


    </keep-alive>


</template>

<script>

import header from './header';
import m_header from './m_header';
import p_header from './p_header';

export default {
    ...header,
    components : {
        m_header,
        p_header
    }
}
</script>